import React, { FC, useEffect, useState } from 'react';
import { Select, Table } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../../../api';
import { routerPath } from '../../../../router/routerPath';
import { CustomButton, CustomSelect, CustomTableContainer, FormBlock, GridItem } from '../../../../styles/styled';
import { NmsMeetingsResponseType, NmsMeetingsType, NmsMeetingType } from '../../../CreateNmsMeetingPage/types';
import { PaginationType } from '../../../ExpertPage/ExpertPage';

const { Option } = Select;

type NmsMaterialsProps = {
  nms?: boolean;
};

export const NmsMaterialsComponent: FC<NmsMaterialsProps> = ({ nms }) => {
  const navigate = useNavigate();
  const [paginationState, setPaginationState] = useState<PaginationType>({ pagination: 1, perPage: 10, count: 0 });
  const [filterState, setFilter] = useState<number | null>(null);
  const [searchState, setSearchState] = useState<boolean | undefined>(false);
  const [nmsMeetingsState, setNmsMeetings] = useState<NmsMeetingsType>([]);

  useEffect(() => {
    if (searchState === undefined) {
      setSearchState(true);

      return;
    }

    (async () => {
      try {
        const response = await api.get<NmsMeetingsResponseType>(
          filterState && searchState ? endpoints.getNmsByFilters(filterState) : endpoints.getNms(),
        );

        const responseNms = response.data.nms;

        if (responseNms.length === 0) {
          setPaginationState({ ...paginationState, pagination: 0, count: 0 });
          setNmsMeetings([]);
        }

        if (paginationState.count === 0 && responseNms.length > 0)
          setPaginationState({ ...paginationState, count: responseNms.filter((el) => !el.archive).length });

        if (responseNms.length > 0)
          setNmsMeetings(
            response.data.nms
              .filter((el) => (nms ? !el.archive && el.access_provided_to_members : !el.archive))
              .map((el, idx) => {
                return { ...el, key: idx + 1 };
              }),
          );
      } catch (err) {}
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState, paginationState.pagination]);

  const searchButtonHandler = () => {
    setSearchState(undefined);
  };

  const nmsColumns = [
    {
      title: '№ п/п',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Дата заседания',
      dataIndex: 'date',
      key: 'date',
      render: (date: string, nmsMaterial: NmsMeetingType) => (
        <div className="text-link align-center">
          <Link to={`/${nms ? routerPath.nmsInfoMeeting : routerPath.nmsFedInfoMeeting}/${nmsMaterial.id}`}>
            {date.split('-').reverse().join('-')}
          </Link>
        </div>
      ),
    },
    {
      title: 'Доступ',
      dataIndex: 'access_provided_to_members',
      key: 'access',
      render: (access: boolean | null) => (
        <p className="align-center">{access ? 'предоставлен' : 'не предоставлен'} </p>
      ),
    },
  ];

  return (
    <FormBlock white noBorderRadius>
      <GridItem gap="20px" direction="column" align="center" justify="center">
        <GridItem width="50%" direction="column" align="flex-start" justify="flex-start">
          <div className="text">Год заседания</div>
          <CustomSelect value={filterState} onChange={(value) => setFilter(value as number)}>
            <Option key={2021} value={2021}>
              2021
            </Option>
            <Option key={2022} value={2022}>
              2022
            </Option>
            <Option key={2023} value={2023}>
              2023
            </Option>
            <Option key={2024} value={2024}>
              2024
            </Option>
            <Option key={2025} value={2025}>
              2025
            </Option>
          </CustomSelect>
        </GridItem>
        <GridItem width="40%" direction="row" align="flex-start" justify="space-around">
          <CustomButton onClick={searchButtonHandler}>Найти</CustomButton>
          <CustomButton
            onClick={() => {
              setFilter(null);
              setSearchState(false);
            }}
            lined
          >
            Очистить
          </CustomButton>
        </GridItem>
        <br />

        {!nms && (
          <GridItem align="flex-end" justify="flex-end">
            <CustomButton width="400px" onClick={() => navigate(routerPath.createNmsMeeting)} lined>
              Добавить заседание НМС
            </CustomButton>
          </GridItem>
        )}
        <CustomTableContainer noOverflow>
          <Table
            columns={nmsColumns}
            locale={{ emptyText: 'Заседаний не обнаружено' }}
            pagination={paginationState.count > 10 ? {} : false}
            dataSource={nmsMeetingsState}
          />
        </CustomTableContainer>
      </GridItem>
    </FormBlock>
  );
};
